





























































































import {Component, Vue, Watch} from 'vue-property-decorator';
import { AxiosStatic } from 'axios';
import IResource from '@/interfaces/IResource';
import Calendar from '../components/Calendar.vue';
import moment from 'moment';

interface ICalendarDay {
	date: Date,
	startTime: number, // hours
	endTime: number, // hours
	height: number // pixels
}
interface IAvailabilityDetails {
	type: 'reservation'|'lock',
	id: number,
	name: string,
	status?: string
}
interface IResourceAvailabilities {
	[dayKey: string]: [number, number, IAvailabilityDetails][]
}
@Component({
	components: {
		Calendar
	}
})

export default class OrganisationCalendarDaily extends Vue {

	public calendarDay: ICalendarDay = {
		date: new Date(),
		startTime: 0, // hours
		endTime: 24, // hours
		height: 400  // pixel
	};
	public selectedDay: Date = new Date();
	public isLoading: boolean = true;
	public designOffsetY = 20;
	public availabilities: { [resourceId: number]: IResourceAvailabilities[] } = {};
	private $http!: AxiosStatic;

	@Watch('resources', { immediate: true})
	public watchResources(newVal: any, oldVal: any) {
		if(this.resources && this.resources.length > 0) {
			if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
				this.isLoading = true;
				this.buildCalendarDay();
				this.loadAvailabilities();
				this.isLoading = false;
			}
		}
	}

	get resources(): IResource[] | null{
		if (this.$store.state.resources) {
			return this.$store.state.resources;
		}
		return null;
	}

	get bookableHoursAmount(): number {
		return this.calendarDay.endTime - this.calendarDay.startTime;
	}

	get calendarDayHoursHeight() {
		return 30;
	}

	get selectedDayStart(): number {
		let date = this.selectedDay ? new Date(this.selectedDay) : new Date();
		date.setHours(0,0,0,0);
		return date.getTime();
	}

	public formatMinutesToTime(minutes: number) : string {
		let hours: number|string = Math.floor(minutes / 60);
		hours = hours < 10 ? '0' + hours : hours;
		let remainingMinutes: number|string = minutes % 60;
		remainingMinutes = remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes;
		return hours + ':' + remainingMinutes;
	}

	public setCalendarDayAttributes(): void {
		let dayAttributes: { start: number, end: number};
		dayAttributes = this.calculateNormalCalendarDayAttributes();
		this.calendarDay.startTime = dayAttributes.start;
		this.calendarDay.endTime = dayAttributes.end;
		this.calendarDay.height = 400;
		this.calendarDay.date = this.selectedDay;
	}

	public calculateNormalCalendarDayAttributes(): { start: number, end: number } {
		let tmpDayStart: number = 24;
		let tmpDayEnd: number = 0;
		if(this.resources) {
			this.resources.forEach((resource) => {
				if(resource.starttime !== null && resource.starttime < tmpDayStart) {
					tmpDayStart = resource.starttime;
				}
				if(resource.endtime && resource.endtime > tmpDayEnd) {
					tmpDayEnd = resource.endtime;
				}
			});
		}
		return {start: tmpDayStart, end: tmpDayEnd};
	}

	public formatDayString(date: Date | null = null): string {
		if(date === null) {
			if(this.selectedDay) {
				date = new Date(this.selectedDay);
			} else {
				date = new Date();
			}
		}
		let month = '' + (date.getMonth() + 1);
		let day = '' + date.getDate();
		let year = date.getFullYear();

		if (month.length < 2)
			month = '0' + month;
		if (day.length < 2)
			day = '0' + day;

		return [day, month, year].join('.');
	}

	public getHeight(availability: [number, number]): number {
		let duration = availability[1] - availability[0]; //minutes
		let durationHours = duration / 60;
		return durationHours * this.calendarDayHoursHeight;
	}

	public getPositionTop(timeslot: [number, number]): number {
		return this.calendarDayHoursHeight * ( timeslot[0] / 60 - this.calendarDay.startTime) + this.designOffsetY;
	}

	public async mounted(): Promise<void> {
		this.selectedDay = new Date();
		this.$store.dispatch('loadResources', {root: true});
	}

	private clearCalendarDay(): void {
		if(this.resources && this.selectedDay !== null) {
			this.calendarDay = {
				date: new Date(this.selectedDay),
				startTime: 0, // hours
				endTime: 24, // hours
				height: 400  // pixel
			}
		}
	}

	private loadAvailabilities(): void {
		if(this.resources && this.resources.length > 0) {
			this.resources.forEach((resource) => {
				let rangeStart = new Date();
				rangeStart.setDate(rangeStart.getDate() - 30);
				let rangeEnd = new Date();
				rangeEnd.setDate(rangeEnd.getDate() + 30);

				// get 30 before and after today
				this.$http.get(`/private/resource/${resource.id}/availability?start=${rangeStart.toISOString().substring(0,10)}&end=${rangeEnd.toISOString().substring(0,10)}`).then((response) => {
					if (response.status !== 200) {
						throw new Error('error getting availability');
					} else {
						Vue.set(this.availabilities, resource.id, response.data);

						// get longer availability
						rangeStart.setFullYear(rangeStart.getFullYear() - 5);
						rangeEnd.setFullYear(rangeEnd.getFullYear() + 15);
						this.$http.get(`/private/resource/${resource.id}/availability?start=${rangeStart.toISOString().substring(0,10)}&end=${rangeEnd.toISOString().substring(0,10)}`).then((response) => {
							if (response.status !== 200) {
								throw new Error('error getting availability');
							} else {
								Vue.set(this.availabilities, resource.id, response.data);
							}
						});
					}
				});
			});
		}
	}

	public dateKey(date: Date): string {
		if (date) {
			return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		}
		return '';
	}

	private buildCalendarDay(): void {
		this.clearCalendarDay();
		this.setCalendarDayAttributes();
	}

	public nextDay() {
		if(this.selectedDay) {
			this.selectedDay.setDate(this.selectedDay.getDate() + 1)
		}
		this.buildCalendarDay();
	}

	public previousDay() {
		if(this.selectedDay) {
			this.selectedDay.setDate(this.selectedDay.getDate() - 1)
		}
		this.buildCalendarDay();
	}

}
